import { COMPLIANCE_REVIEWS_LOCAL_STATUS } from "@/constants";

export default {
  getComplianceReviewListInit(state) {
    state.complianceReviewList.status = COMPLIANCE_REVIEWS_LOCAL_STATUS.LOADING;
  },
  getComplianceReviewListSuccess(state, { data }) {
    state.complianceReviewList.status =
      COMPLIANCE_REVIEWS_LOCAL_STATUS.LOAD_SUCCESS;

    state.complianceReviewList.data = data;
  },
  getComplianceReviewListError(state, { error }) {
    state.complianceReviewList.status =
      COMPLIANCE_REVIEWS_LOCAL_STATUS.LOAD_ERROR;

    state.complianceReviewList.error = error;
  },

  getComplianceReviewItemInit(state) {
    state.complianceReviewItem.status = COMPLIANCE_REVIEWS_LOCAL_STATUS.LOADING;
  },
  getComplianceReviewItemSuccess(state, { data }) {
    state.complianceReviewItem.status =
      COMPLIANCE_REVIEWS_LOCAL_STATUS.LOAD_SUCCESS;

    state.complianceReviewItem.data = data;
  },
  getComplianceReviewItemError(state, { error }) {
    state.complianceReviewItem.status =
      COMPLIANCE_REVIEWS_LOCAL_STATUS.LOAD_ERROR;

    state.complianceReviewItem.error = error.message;
  },

  putResolveComplianceReviewInit(state) {
    state.complianceReviewItem.status = COMPLIANCE_REVIEWS_LOCAL_STATUS.LOADING;
  },
  putResolveComplianceReviewSuccess(state) {
    state.complianceReviewItem.status =
      COMPLIANCE_REVIEWS_LOCAL_STATUS.LOAD_SUCCESS;
  },
  putResolveComplianceReviewError(state, { error }) {
    state.complianceReviewItem.status =
      COMPLIANCE_REVIEWS_LOCAL_STATUS.LOAD_ERROR;
    state.complianceReviewItem.error = error.message;
  }
};
